import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';

/** Shallow, repeating woodland and roofline bands. No full-height foreground trunks. */
export const WICKHAVEN_SILHOUETTES: Readonly<Record<'far' | 'mid' | 'near', ParallaxSvgSpec>> = {
  far: {
    tile: {
      viewBoxWidth: 1600, viewBoxHeight: 200,
      path: 'M0 200V120 C40 118 65 82 104 86 C110 52 140 36 174 55 '
        + 'C192 24 238 30 250 66 C291 58 318 87 330 119 '
        + 'C360 118 402 99 440 108 C454 66 494 56 522 83 '
        + 'C549 48 592 55 604 95 C645 81 678 99 704 122 '
        + 'C751 128 781 102 810 101 C820 66 851 42 882 59 '
        + 'C905 30 948 39 958 70 C991 61 1020 89 1036 117 '
        + 'C1080 124 1112 104 1150 109 C1168 76 1207 56 1232 82 '
        + 'C1262 61 1296 81 1307 112 C1344 102 1371 118 1400 124 '
        + 'C1450 133 1520 116 1600 120V200Z',
    },
  },
  mid: {
    tile: {
      viewBoxWidth: 1600, viewBoxHeight: 160,
      path: 'M0 160V113H94V91L150 47L206 91V113H262V85H269V59H281V85H302V111 '
        + 'H398V101L465 51L532 101V115H620V94L665 67L710 94V113 '
        + 'H827V85L900 31L973 85V112H1020V74H1034V58H1050V112 '
        + 'H1130V96L1186 55L1242 96V114H1370V91L1428 48L1486 91V113H1600V160Z',
    },
  },
  near: {
    tile: {
      viewBoxWidth: 1600, viewBoxHeight: 100,
      path: 'M0 100V72 C90 69 144 77 220 74 L220 53H230V74 '
        + 'C316 69 392 75 462 73 L462 50H472V72 '
        + 'C550 70 623 75 700 74 L700 63H706V48H720V63H726V74 '
        + 'C807 76 879 69 968 73 L968 51H978V74 '
        + 'C1080 73 1167 78 1246 73 L1246 55H1256V73 '
        + 'C1370 69 1495 72 1600 72V100Z',
    },
  },
};
